// Extra feature sections built from help center articles.
export const MORE_BRAND = {
    marketing: {
        tabLinks: {
            "campaign-targeting": "/help-center/knowledge-base/marketing/target-clients-with-filters#use-filters",
            "fill-open-time": "/help-center/knowledge-base/marketing/create-text-campaigns#create-a-text-campaign",
            "win-back": "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
            "automated-milestones": "/help-center/knowledge-base/marketing/automated-client-messages#after-appointment-messages",
        },
        sections: [
            {
                type: "row",
                title: "Every campaign in one place",
                description: "See all your sent email and text campaigns on one page, and filter them by channel. Open any campaign to check its details.",
                image: "marketing/marketing-page",
                href: "/help-center/knowledge-base/marketing/create-email-campaigns#view-sent-campaigns",
                linkLabel: "See my campaigns",
            },
            {
                type: "group",
                heading: "Launch a campaign in minutes",
                intro: "Pick a channel, start from a template and send to the clients you choose.",
                cards: [
                    {
                        title: "Email or text, one menu",
                        description: "Start an email campaign, a text campaign or top up your text credits from a single Add menu.",
                        image: "marketing/marketing-add-menu",
                        href: "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
                        linkLabel: "Start a campaign",
                    },
                    {
                        title: "Reuse what works",
                        description: "Save your best offers as email or text templates. Pick one while creating a campaign and the content fills in for you.",
                        image: "marketing/marketing-templates",
                        href: "/help-center/knowledge-base/marketing/manage-marketing-templates#create-a-template",
                        linkLabel: "Build a template",
                    },
                ],
            },
            {
                type: "row",
                title: "Grow your Google reviews",
                description: "Add your Google review link to the thank-you message clients get after their visit. Only clients who rate you at or above your minimum are prompted.",
                image: "online-presence/google-rating-boost",
                href: "/help-center/knowledge-base/online-presence/google-rating-boost#turn-on-google-rating-boost",
                linkLabel: "Boost my rating",
            },
            {
                type: "group",
                heading: "Turn every channel into bookings",
                cards: [
                    {
                        title: "Links made for promotions",
                        description: "Create booking links for campaigns, social posts and ads that open straight to the services you choose.",
                        image: "online-presence/link-builder",
                        href: "/help-center/knowledge-base/online-presence/create-booking-links#link-types",
                        linkLabel: "Create a link",
                    },
                    {
                        title: "Book from Google and social",
                        description: "Follow the step-by-step guide to add your booking link to Google, Facebook and Instagram.",
                        image: "online-presence/social-booking-setup",
                        href: "/help-center/knowledge-base/online-presence/set-up-social-and-google-booking#open-the-setup-guide",
                        linkLabel: "Connect my profiles",
                    },
                ],
            },
            {
                type: "row",
                title: "Gift card deals that sell",
                description: "Run promotions like a $120 gift card for $100 around the holidays. Running promotions show on your online gift card page and at checkout.",
                image: "gift-cards/gift-card-promotion",
                href: "/help-center/knowledge-base/packages-and-gift-cards/create-gift-card-promotions#add-a-promotion",
                linkLabel: "Create a promotion",
            },
            {
                type: "row",
                title: "Know what reached clients",
                description: "Messages history lists every email and text sent, including campaigns, with a status for each one so you can spot what didn't arrive.",
                image: "marketing/messages-history",
                href: "/help-center/knowledge-base/marketing/view-messages-history#message-statuses",
                linkLabel: "Check message status",
            },
        ],
    },
    "email-marketing": {
        tabLinks: {
            compose: "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
            audience: "/help-center/knowledge-base/marketing/target-clients-with-filters#use-filters",
            templates: "/help-center/knowledge-base/marketing/manage-marketing-templates#create-a-template",
            "review-send": "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
        },
        sections: [
            {
                type: "row",
                title: "Email the clients who matter most",
                description: "Filter by last visit, number of appointments, total spend, past services or past retail, so each email reaches the right people.",
                image: "marketing/campaign-client-filters",
                href: "/help-center/knowledge-base/marketing/target-clients-with-filters#use-filters",
                linkLabel: "Target my clients",
            },
            {
                type: "group",
                heading: "Simple from start to sent",
                cards: [
                    {
                        title: "No extra sending fees",
                        description: "Start an email campaign from the Marketing Add menu. There are no extra fees for sending emails.",
                        image: "marketing/marketing-add-menu",
                        href: "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
                        linkLabel: "Send an email",
                    },
                    {
                        title: "Every email on record",
                        description: "Sent campaigns are listed on the Blast campaigns page, with an Email tab to see just your emails.",
                        image: "marketing/marketing-page",
                        href: "/help-center/knowledge-base/marketing/create-email-campaigns#view-sent-campaigns",
                        linkLabel: "View sent emails",
                    },
                ],
            },
            {
                type: "row",
                title: "See who opened and clicked",
                description: "Messages history shows whether each email was delivered, opened or clicked, so you know your message landed.",
                image: "marketing/messages-history",
                href: "/help-center/knowledge-base/marketing/view-messages-history#message-statuses",
                linkLabel: "Track my emails",
            },
            {
                type: "group",
                heading: "Emails that keep working after the visit",
                intro: "Set them up once and they go out on their own.",
                cards: [
                    {
                        title: "Thank-yous and birthdays",
                        description: "Send a thank-you note after each appointment, a rebooking reminder and a birthday message automatically.",
                        image: "marketing/automated-messages",
                        href: "/help-center/knowledge-base/marketing/automated-client-messages#after-appointment-messages",
                        linkLabel: "Automate my emails",
                    },
                    {
                        title: "Ask for a Google review",
                        description: "Add your Google review link to the thank-you email, shown to clients who rate you at or above your minimum.",
                        image: "online-presence/google-rating-boost",
                        href: "/help-center/knowledge-base/online-presence/google-rating-boost#turn-on-google-rating-boost",
                        linkLabel: "Get more reviews",
                    },
                ],
            },
            {
                type: "row",
                title: "Gift cards straight to the inbox",
                description: "Email a digital gift card with a personal gift message. Send it now or schedule it for a set date.",
                image: "gift-cards/gift-card-send",
                href: "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards#send-a-digital-gift-card",
                linkLabel: "Send a gift card",
            },
            {
                type: "row",
                title: "Respect every client's wishes",
                description: "Turn on Skip Google review requests for clients who don't want review invitations, and switch off any automated message you don't need.",
                image: "clients/client-edit-form",
                href: "/help-center/knowledge-base/privacy-and-security/manage-client-data#communication-preferences",
                linkLabel: "Manage preferences",
            },
        ],
    },
    "text-marketing": {
        tabLinks: {
            "text-campaigns": "/help-center/knowledge-base/marketing/create-text-campaigns#create-a-text-campaign",
            targeting: "/help-center/knowledge-base/marketing/target-clients-with-filters#use-filters",
            credits: "/help-center/knowledge-base/marketing/buy-sms-credits#buy-credits",
            history: "/help-center/knowledge-base/marketing/view-messages-history#open-messages-history",
        },
        sections: [
            {
                type: "row",
                title: "Save your best texts",
                description: "Keep your go-to offers as Text (SMS) templates with an optional link and image. Pick one and your campaign is ready.",
                image: "marketing/marketing-templates",
                href: "/help-center/knowledge-base/marketing/manage-marketing-templates#create-a-template",
                linkLabel: "Create a text template",
            },
            {
                type: "group",
                heading: "Clear, simple credits",
                intro: "A text-only message uses 1 credit per client, and a message with an image uses 3.",
                cards: [
                    {
                        title: "Your balance at a glance",
                        description: "Your remaining SMS credits are shown at the top of the Blast campaigns page, with Buy more right next to them.",
                        image: "marketing/marketing-add-menu",
                        href: "/help-center/knowledge-base/marketing/buy-sms-credits#buy-credits",
                        linkLabel: "Top up credits",
                    },
                    {
                        title: "Pay with referral credit",
                        description: "Refer another business and use the credit you earn toward SMS credit purchases.",
                        image: "billing-and-fees/referrals",
                        href: "/help-center/knowledge-base/billing-and-fees/refer-a-business#share-your-link",
                        linkLabel: "Refer a business",
                    },
                ],
            },
            {
                type: "row",
                title: "Put a booking link in every text",
                description: "Create a booking link for just the services you're promoting, then paste it into your text so clients can book in a tap.",
                image: "online-presence/link-builder-result",
                href: "/help-center/knowledge-base/online-presence/create-booking-links#create-a-link",
                linkLabel: "Build a booking link",
            },
            {
                type: "group",
                heading: "Texts that send themselves",
                cards: [
                    {
                        title: "Text reminders before visits",
                        description: "Choose how long before the appointment a reminder goes out and turn on Send a text message.",
                        image: "calendar/automated-reminder-edit",
                        href: "/help-center/knowledge-base/calendar/send-appointment-reminders#set-up-reminders",
                        linkLabel: "Set up reminders",
                    },
                    {
                        title: "Waitlist alerts by text",
                        description: "Let clients know by text when they join the waitlist or are removed from it.",
                        image: "calendar/automated-waitlist-edit",
                        href: "/help-center/knowledge-base/calendar/send-waitlist-updates#set-up-waitlist-updates",
                        linkLabel: "Text my waitlist",
                    },
                ],
            },
            {
                type: "row",
                title: "Every text campaign on file",
                description: "Sent campaigns are listed on the Blast campaigns page. Use the Text tab to see only your text campaigns.",
                image: "marketing/marketing-page",
                href: "/help-center/knowledge-base/marketing/create-email-campaigns#view-sent-campaigns",
                linkLabel: "View text campaigns",
            },
            {
                type: "row",
                title: "Respect client preferences",
                description: "Every marketing text ends with \"Reply STOP to unsubscribe\", and you can skip Google review requests for clients who don't want them.",
                image: "clients/client-edit-form",
                href: "/help-center/knowledge-base/privacy-and-security/manage-client-data#communication-preferences",
                linkLabel: "Respect preferences",
            },
        ],
    },
    notifications: {
        tabLinks: {
            reminders: "/help-center/knowledge-base/calendar/send-appointment-reminders#set-up-reminders",
            "appointment-updates": "/help-center/knowledge-base/calendar/send-appointment-updates#turn-updates-on-or-off",
            waitlist: "/help-center/knowledge-base/calendar/send-waitlist-updates#set-up-waitlist-updates",
            "increase-bookings": "/help-center/knowledge-base/marketing/automated-client-messages#after-appointment-messages",
        },
        sections: [
            {
                type: "row",
                title: "Confirm bookings as you make them",
                description: "Tick Notify client via email or text when you book, and the client gets a booking confirmation right away.",
                image: "calendar/appointment-review",
                href: "/help-center/knowledge-base/calendar/create-appointments#book-a-specific-time-slot",
                linkLabel: "Book and notify",
            },
            {
                type: "group",
                heading: "You decide when clients hear from you",
                intro: "Cancellation and no-show messages only go out when the notify option is ticked.",
                cards: [
                    {
                        title: "Cancel with a heads-up",
                        description: "When you cancel an appointment, choose whether to notify the client by email and text.",
                        image: "calendar/appointment-cancel-dialog",
                        href: "/help-center/knowledge-base/calendar/cancel-appointments#cancel-an-appointment",
                        linkLabel: "Cancel an appointment",
                    },
                    {
                        title: "No-show notices",
                        description: "Keep Send a no-show notification selected to let the client know, or clear it to stay quiet.",
                        image: "calendar/appointment-no-show-dialog",
                        href: "/help-center/knowledge-base/calendar/mark-appointments-as-no-shows#mark-a-no-show",
                        linkLabel: "Mark a no-show",
                    },
                ],
            },
            {
                type: "row",
                title: "Reschedule without surprises",
                description: "Choose what happens when an appointment is dragged on the calendar: ask every time, always notify or never notify.",
                image: "calendar/calendar-settings",
                href: "/help-center/knowledge-base/calendar/customize-calendar-settings#business-settings",
                linkLabel: "Set my preference",
            },
            {
                type: "row",
                title: "Resend details in one click",
                description: "Client lost their confirmation? Use Resend appointment details to send their booking details again.",
                image: "calendar/appointment-more-menu",
                href: "/help-center/knowledge-base/calendar/update-appointments#view-change-history",
                linkLabel: "Resend details",
            },
            {
                type: "group",
                heading: "Turn happy visits into reviews",
                cards: [
                    {
                        title: "Review us on Google",
                        description: "Add your Google review link to the thank-you message, shown to clients who rate you at or above your minimum.",
                        image: "online-presence/google-rating-boost",
                        href: "/help-center/knowledge-base/online-presence/google-rating-boost#turn-on-google-rating-boost",
                        linkLabel: "Boost my rating",
                    },
                    {
                        title: "Skip it for some clients",
                        description: "Turn on Skip Google review requests on a client's profile to leave the review link out for them.",
                        image: "clients/client-edit-form",
                        href: "/help-center/knowledge-base/clients/update-client-details#stop-google-review-requests",
                        linkLabel: "Edit a client",
                    },
                ],
            },
            {
                type: "row",
                title: "Proof every message went out",
                description: "Messages history lists every email and text sent to clients, with its channel, type and delivery status.",
                image: "marketing/messages-history",
                href: "/help-center/knowledge-base/marketing/view-messages-history#open-messages-history",
                linkLabel: "View message history",
            },
            {
                type: "row",
                title: "Alerts for your team too",
                description: "Each team member chooses whether they hear about new appointments and waitlist sign-ups by email, text or both.",
                image: "personal-account/user-preferences",
                href: "/help-center/knowledge-base/personal-account/set-your-notification-preferences#choose-notifications",
                linkLabel: "Set my alerts",
            },
        ],
    },
    branding: {
        tabLinks: {
            "branded-touchpoints": "/help-center/knowledge-base/online-presence/how-clients-book-online#the-booking-journey",
            "booking-polish": "/help-center/knowledge-base/online-presence/how-clients-book-online#the-booking-journey",
            "gift-card-design": "/help-center/knowledge-base/packages-and-gift-cards/set-up-gift-cards#artwork",
            "design-consistency": "/help-center/knowledge-base/marketing/manage-marketing-templates#create-a-template",
        },
        sections: [
            {
                type: "row",
                title: "A service menu that sells",
                description: "Your booking site lists your services by category, showing only the ones you choose to put online.",
                image: "online-presence/booking-site-services",
                href: "/help-center/knowledge-base/online-presence/how-clients-book-online#what-shapes-the-booking-site",
                linkLabel: "See the booking site",
            },
            {
                type: "group",
                heading: "Your look, wherever clients book",
                cards: [
                    {
                        title: "Book from your own website",
                        description: "Add a Book button to your website that opens your booking site in a pop-up, so visitors never leave your page.",
                        image: "online-presence/website-widget-code",
                        href: "/help-center/knowledge-base/online-presence/add-a-book-button-to-your-website#add-the-widget",
                        linkLabel: "Add a Book button",
                    },
                    {
                        title: "Google, Facebook and Instagram",
                        description: "Add your booking link to your Google, Facebook and Instagram profiles with a step-by-step guide.",
                        image: "online-presence/social-booking-setup",
                        href: "/help-center/knowledge-base/online-presence/set-up-social-and-google-booking#open-the-setup-guide",
                        linkLabel: "Connect my profiles",
                    },
                ],
            },
            {
                type: "row",
                title: "A gift card shop that fits your brand",
                description: "Sell gift cards online through a shareable link, showing the artwork you picked and your own purchase terms.",
                image: "gift-cards/gift-card-online-sales",
                href: "/help-center/knowledge-base/packages-and-gift-cards/set-up-gift-cards#online-sales",
                linkLabel: "Sell gift cards online",
            },
            {
                type: "row",
                title: "Campaigns with your images",
                description: "Upload your own image to each email campaign and watch the preview update as you write.",
                image: "marketing/email-campaign-message",
                href: "/help-center/knowledge-base/marketing/create-email-campaigns#create-a-campaign",
                linkLabel: "Design an email",
            },
            {
                type: "group",
                heading: "Polished touches clients notice",
                cards: [
                    {
                        title: "Personal gift messages",
                        description: "Send digital gift cards with the recipient's name and your own gift message, now or on a set date.",
                        image: "gift-cards/gift-card-send",
                        href: "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards#send-a-digital-gift-card",
                        linkLabel: "Send a gift card",
                    },
                    {
                        title: "QR codes for print",
                        description: "Turn any booking link into a QR code and download it for posters, flyers or your front desk.",
                        image: "online-presence/link-builder-qr",
                        href: "/help-center/knowledge-base/online-presence/create-booking-links#create-a-link",
                        linkLabel: "Make a QR code",
                    },
                ],
            },
            {
                type: "row",
                title: "Seasonal offers, your way",
                description: "Give each gift card promotion its own display name and description. Running promotions appear on your online sales page.",
                image: "gift-cards/gift-card-promotion",
                href: "/help-center/knowledge-base/packages-and-gift-cards/create-gift-card-promotions#add-a-promotion",
                linkLabel: "Create a promotion",
            },
        ],
    },
};
